<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="DEDICATION">
<header>
<p class="h2f" id="bk4ded"><span class="right_1" epub:type="pagebreak" id="page_318" title="318"><span class="right_1" epub:type="pagebreak" id="page_319" title="319">DEDICATION</span></span></p>
</header>
<p class="ded"><i>To James. I love you.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780718023676_Book_4ded.vue?3134fef0